import './ErrorPage.css'
export default function ErrorPage(props) {


    return <div className="ErrorPage">

        <><div className='section'><div className='cover-img'>
            <div className='header-cover-title tickets_main_title almoni_tzar_normal p-1 d-flex align-items-end justify-content-center'>
                <span>{props.errorMessageHead + ' :('}</span>
            </div></div>   </div><div className="alert alert-text">{props.errorMessageHead}</div> </>
    </div>
}